export default __webpack_public_path__ + "img/5b0ac9bea0dc4bcfd28130805c6930da.svg";